import { Button } from 'components';
import styled from 'styled-components';
import { MASKED_TEXT_CLASS } from 'analytics/constants';
import { StatusBarActionButton } from 'widgets/audio/AudioStatusBar.styles';
import { TONE_SURFACES } from 'widgets/audio/toneSurfaces';

export const StatusTitle = styled.p.attrs({
  className: 'min-w-0 flex-1 text-xs font-semibold text-muted-foreground',
})``;

export const ActiveBar = styled.div.attrs({
  className: 'border-t border-border bg-card p-3',
})``;

export const ActiveBarContent = styled.div.attrs({
  className: 'mx-auto flex w-full max-w-6xl items-center gap-2',
})``;

export const RecordingStatusSection = styled.div.attrs({
  className: 'flex min-w-0 flex-1 items-center',
})``;

export const Controls = styled.div.attrs({
  className: 'flex shrink-0 items-center gap-1',
})``;

export const ElapsedTimeChip = styled.span.attrs({
  className:
    'flex h-5 min-w-5 items-center justify-center rounded-sm bg-background/20 px-1 text-xs font-medium text-background tabular-nums',
})``;

export const IndicatorWrap = styled.span.attrs({
  className: 'flex h-6 w-16 items-end mr-3',
})``;

export const IndicatorPing = styled.span.attrs<{ color?: 'red' | 'white' }>(
  ({ color = 'red' }) => ({
    className: `animate-ping motion-reduce:animate-none absolute inline-flex h-full w-full rounded-full ${color === 'red' ? 'bg-red-600' : 'bg-white'} opacity-75`,
  })
)<{ color?: 'red' | 'white' }>``;

export const ControlButton = styled(Button).attrs({
  size: 'sm',
})``;

export const CancelButton = styled(Button).attrs({
  variant: 'destructive',
  size: 'icon-sm',
  className: 'size-8 p-0',
})``;

export const BottomBarContainer = styled.div.attrs({
  className: 'flex w-full max-w-6xl mx-auto justify-center flex-col gap-2',
})``;

export const BottomBarContent = styled.div.attrs({
  className: 'flex justify-center items-center gap-3',
})``;

export const LanguageSelectorContainer = styled.div``;

export const LanguageSelectorButton = styled(Button).attrs({
  variant: 'secondary',
  className: 'min-w-22 rounded-xl bg-white border border-[#D4D4D4]',
})``;

export type RecordingAlertVariant = 'error' | 'error-soft' | 'success' | 'warning';

const RECORDING_ALERT_CLASSES: Record<RecordingAlertVariant, string> = {
  error: 'bg-destructive text-white',
  'error-soft': TONE_SURFACES.error,
  success: 'bg-green-600 text-white',
  warning: TONE_SURFACES.warning,
};

export const RecordingAlertBox = styled.div.attrs<{ $variant?: RecordingAlertVariant }>(
  ({ $variant = 'error' }) => ({
    className: `flex items-center justify-between gap-4 px-4 py-3 ${RECORDING_ALERT_CLASSES[$variant]}`,
  })
)<{ $variant?: RecordingAlertVariant }>``;

export const RecordingAlertText = styled.div.attrs({
  className: 'flex items-start gap-3 min-w-0',
})``;

export const RecordingAlertTitle = styled.p.attrs<{ $masked?: boolean }>(({ $masked }) => ({
  className: `text-sm font-semibold ${$masked ? MASKED_TEXT_CLASS : ''}`,
}))<{ $masked?: boolean }>``;

export const RecordingAlertBanner = styled.p.attrs<{ $masked?: boolean }>(({ $masked }) => ({
  className: `text-sm opacity-80 ${$masked ? MASKED_TEXT_CLASS : ''}`,
}))<{ $masked?: boolean }>``;

export const DeviceProblemAction = styled(StatusBarActionButton).attrs({
  className: 'shrink-0',
})``;

export const StartActionRow = styled.div.attrs({
  className: 'flex flex-row w-full items-center justify-center gap-2',
})``;

export const StartActionSlot = styled.div.attrs({
  className: 'flex-1',
})``;

export const SearchingNotice = styled.span.attrs({
  className: 'sr-only',
})``;
